module.exports = __webpack_public_path__ + "static/media/financial-worries-large@3x.4ea379d0.png";